import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Snackbar,
  Alert,
} from '@mui/material';

const SystemReady = ({ systemReadyHardware, onSystemReadyDelete, onVideoCallAdd }) => {
  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const handleVideoCall = (row) => {
    if (typeof onVideoCallAdd === 'function') {
      onVideoCallAdd(row);
      setOpenSnackbar(true);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          Video call initiated!
        </Alert>
      </Snackbar>
      <Typography variant="h4" gutterBottom>
        System Ready
      </Typography>
      <Grid container spacing={3}>
        {systemReadyHardware && systemReadyHardware.length > 0 ? (
          systemReadyHardware.map((row) => (
            <Grid item xs={12} key={row.id}>
              <Card sx={{ boxShadow: 3 }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    {row['Customer Name']}
                  </Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Place:</strong> {row.Place}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Date:</strong> {row.Date}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Time:</strong> {row.Time}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Serial No:</strong> {row['Serial No']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>System Name:</strong> {row['System Name']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Contact Number:</strong> {row['Contact Number']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Customer ID:</strong> {row['Customer ID']}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Address:</strong> {row.Address}</Typography>
                  <Typography variant="body2" color="text.secondary"><strong>Customer Issue:</strong> {row['Customer Issue']}</Typography>
                </CardContent>
                <CardActions>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Button fullWidth variant="contained" color="secondary" onClick={() => handleVideoCall(row)}>Video call</Button>
                    </Grid>
                  </Grid>
                </CardActions>
              </Card>
            </Grid>
          ))
        ) : (
          <Typography variant="body1">No systems ready.</Typography>
        )}
      </Grid>
    </Box>
  );
};

export default SystemReady;